import React, {Component, Fragment, PureComponent} from "react";
import ReactSVG from "react-svg";
import EventHelper from "../../../helpers/EventHelper";
import ACTIONS from "../../../constants/actions";
import {connect} from "react-redux";
import {addToCoupon} from "../../../redux/actions/coupon";
import FactorsHelper from "../../../helpers/FactorsHelper";
import {setTracker, toggleTracker} from "../../../redux/actions/tracker";
import EventDop from "./EventDop";
import EventTimer from "./EventTimer";
import Factor from "./Factor";
import MomentDate from "../../MomentDate";
import COLUMNS_TITLE from "../../../constants/columns_title";

class EventData extends Component {
	state = {
		isDopOpened : false,
		activeTab   : 0,
	};

	sportSettings = [];

	componentWillMount() {
		const {factorsSettings} = this.props;
		this.sportSettings =
			factorsSettings.sports.filter((sport) => {return sport.id === parseInt(this.props.event.sport_id)})[0];

		this.setState({isDopOpened : this.props.isDopShow});
	}

	videoOnline(videoId) {
		EventHelper.openVideoOnline(videoId);
	}

	openStatistic(statistic) {
		EventHelper.openStatistic(statistic);
	}

	toggleFavorite() {
		const {event} = this.props;
		this.props.toggleFavorite(event.id);
	}

	toggleDopHandler() {
		this.setState({
			isDopOpened : !this.state.isDopOpened
		});
	}

	setTracker(trackerId) {
		if ( trackerId === this.props.tracker.trackerId ) {
			this.props.onToggleTracker();
		}
		else {
			this.props.onSetTracker(trackerId);
		}
	}

	setActiveTab(tabId) {
		this.setState({
			activeTab : tabId
		});
	}

	componentWillReceiveProps(nextProps) {
		if ( nextProps.isDopShow !== this.props.isDopShow ) {
			this.setState({isDopOpened : nextProps.isDopShow});
		}
	}

	render() {
		const {event, factors, league, type, highlight, factorsSettings} = this.props;
		const {score, turn, period, points, timer, game, gameNum, periodNum, isFinished, comment} = EventHelper.parseResults(event.results);
		const description = EventHelper.parseDescription(event.description);

		const eventFavorite = type === 'line' ? '№' :
			<span className={`stars ${this.props.favorites.indexOf(this.props.event.id) !== -1 && 'activated'}`}
			      onClick={this.toggleFavorite.bind(this)}></span>;

		const factorsHelper = new FactorsHelper(event, factors, factorsSettings);
		const columns = factorsHelper.getColumns();

		let commentData = comment !== undefined ? comment : '';
		if ( isFinished ) {
			commentData = comment;
		}

		let periodComment = '';
		if ( +event.sport_id === 3 && periodNum !== undefined && gameNum !== undefined ) {
			periodComment = <span>{`${factorsHelper.printPeriod(periodNum)}: ${gameNum}-й гейм`}</span>;
		}

		if ( +event.sport_id === 2 && periodNum !== undefined ) {
			periodComment = <span>{factorsHelper.printPeriod(periodNum)}</span>;
		}

		if ( +event.sport_id === 2 && period !== undefined && period > 0 && period % 2 === 0 ) {
			periodComment = 'Перерыв';
		}

		if ( commentData !== '' && commentData !== undefined ) {
			const linkMatch = /([^\"=]{2}|^)((https?):\/\/\S+[^\s.,> )\];'\"!?])/;
			const subst = '$1<a href="$2" target="_blank">$2</a>';

			if ( commentData.match(linkMatch) ) {
				commentData = commentData.replace(linkMatch, subst);
			}
		}

		const fCount = factors.length;
		let i = 1000;
		const headData = Object.entries(factorsHelper.getRows()).map(([period, value]) => {
			const cols = columns.map((column) => {
				const item = value[column];

				if ( item === undefined ) {
					return (<td className="koeff" key={column}>&nbsp;</td>);
				}

				if ( item.hasOwnProperty('isKoeff') && !item.isKoeff ) {
					return <td className="koeff" key={i++}><strong>{item.data}</strong></td>
				}

				return (
					<td key={i++} className="koeff">
						<Factor item={item} type={type}/>
					</td>
				)
			});

			if ( parseInt(period) === 0 ) {
				// if ( type !== 'line' ) {
				// 	cols.push(
				// 		<td className="event__information-actions">
				// 			<div className="service">
				// 				{description.getTracker() !== '' &&
				// 				<div className="tracker services-colored__zone" onClick={this.setTracker.bind(this, description.getTracker())}></div>}
				//
				// 				{description.getVideoOnline() !== '' &&
				// 				<div className="translation services-colored__translation" title="Смотреть видеотрансляцию" onClick={this.videoOnline.bind(this, description.getVideoOnline())}></div>}
				//
				// 				{description.getStatistic() !== '' &&
				// 				<div className="statistics" title="Статистика" onClick={this.openStatistic.bind(this, description.getStatistic())}>
				// 					<ReactSVG path={require("../../../../assets/images/svg/statistic.svg")}/>
				// 				</div>}
				// 			</div>
				// 		</td>
				// 	);
				// }

				return (
					<tr key={i++}>
						<td className="number underline">{event.num}</td>

						{type === 'line' &&
						<td className="time underline">
							<MomentDate date={event.time}
							            withTitle={true}
							            isParseAll={false}
							            isShortDate={true}/>
						</td>}

						<td className="event underline">
							<div>
								{event.team1}
								{(turn !== undefined && turn === 1) && <div className="dot green priority"></div>}
							</div>
							<div>
								{event.team2}
								{(turn !== undefined && turn === 2) && <div className="dot green priority"></div>}
							</div>
						</td>

						{fCount === 0 ?
							<td colSpan={columns.length} className="event__stopped">Прием ставок
								приостановлен</td> : cols}

						{type !== 'line' &&
						<td className="event__information-actions">
							<div className="service">
								{description.getTracker() !== '' &&
								<div className="tracker services-colored__zone" onClick={this.setTracker.bind(this, description.getTracker())}></div>}

								{description.getVideoOnline() !== '' &&
								<div className="translation services-colored__translation" title="Смотреть видеотрансляцию" onClick={this.videoOnline.bind(this, description.getVideoOnline())}></div>}

								{/*{description.getStatistic() !== '' &&*/}
								{/*<div className="statistics" title="Статистика" onClick={this.openStatistic.bind(this, description.getStatistic())}>*/}
									{/*<ReactSVG path={require("../../../../assets/images/svg/statistic.svg")}/>*/}
								{/*</div>}*/}
							</div>
						</td>}

					</tr>
				)
			}

			return (
				<tr key={i++}>
					<td className="number"></td>
					{type === 'line' && <td className="time"></td>}
					<td className="periods">{factorsHelper.printPeriod(period)}</td>

					{cols}

					{type !== 'line' && <td className="">&nbsp;</td>}
				</tr>
			);
		});
		const bodyRows = factorsHelper.getBodyRows();
		const bodyCount = factorsHelper.getBodyRowsCount();

		const dopItems = [
			{
				key   : 0,
				value : 'Все',
			},
			{
				key   : 1,
				value : 'Тоталы',
			},
			{
				key   : 2,
				value : 'Инд. тоталы'
			},
			{
				key   : 3,
				value : 'Форы'
			}
		];

		return (
			<div className={`event__data ${(highlight !== null && highlight === event.id) && 'highlight'}`}>
				<table className="event__table">
					<thead>
						<tr className="header event__data-header">
							<th className="number">
								{eventFavorite}
							</th>

							{type === 'line' && <th className="time">Время</th>}

							<th className="event">Событие</th>

							{columns.map((column) =>
								<th key={column} className="koeff" title={COLUMNS_TITLE[column]}>{column}</th>)}

							{type !== 'line' && <th className="event__information-actions">&nbsp;</th>}

							{type === 'line' &&
							<th className="koeff">
								{description.getStatistic() !== '' &&
								<div className="line-statistics" title="Статистика" onClick={this.openStatistic.bind(this, description.getStatistic())}>
									<ReactSVG path={require("../../../../assets/images/svg/statistic.svg")}/>
								</div>}
							</th>}
						</tr>
					</thead>

					<tbody>
						{headData}
					</tbody>

					{type !== 'line' &&
					<tbody>
						<tr className="event__information">
							<td className="event__information-comment" colSpan={2} style={{textAlign : "right"}}>
								<div className="event__information-comment__score">
									<span>{score}</span>
									{points !== undefined && <span>&nbsp;{points.data}</span>}
								</div>
							</td>

							<td colSpan={1000} style={{textAlign : "right"}}>
								{commentData !== '' &&
								<div className="event__information-comment__data" dangerouslySetInnerHTML={{__html : commentData}}></div>}

								<div className="event__information-score">
									<span>{periodComment}</span>
								</div>

								{timer !== 0 && <EventTimer time={timer}/>}
							</td>
						</tr>
					</tbody>}
				</table>

				{bodyCount > 0 &&
				<div className="event__dop">

					<div className="event__dop-header" onClick={this.toggleDopHandler.bind(this)}>
						<div>Доп. коэффициенты
							<sup>{bodyCount}</sup>&nbsp;
							<i className={`fas fa-chevron-down event__dop-toggle ${this.state.isDopOpened && 'rotate'}`}></i>
						</div>
					</div>

					{/*<div className={`event__dop-data ${(type !== 'line' || this.state.isDopOpened) && 'show'}`}>*/}
					<div className={`event__dop-data ${this.state.isDopOpened && 'show'}`}>
						<div className="tabs">
							<ul>
								{dopItems.map((item) =>
									<li key={item.key} onClick={this.setActiveTab.bind(this, item.key)}
									    className={this.state.activeTab === item.key ? 'active' : ''}>{item.value}</li>)}
							</ul>

							<EventDop factors={bodyRows} type={type} activeTab={this.state.activeTab}/>
						</div>
					</div>
				</div>}
			</div>
		)
	}
}

export default connect(
	state => ({
		tracker         : state.tracker,
		factorsSettings : state.main.factors,
		favorites       : state.favorites,
		isDopShow       : state.main.isDopShow
	}),
	dispatch => ({
		toggleFavorite  : (data) => {
			dispatch({type : ACTIONS.FAVORITES.TOGGLE, data : data})
		},
		onAddToCoupon   : (eventId, hash) => {
			dispatch(addToCoupon(eventId, hash));
		},
		onSetTracker    : (trackerId) => {
			dispatch(setTracker(trackerId));
		},
		onToggleTracker : () => {
			dispatch(toggleTracker());
		}
	})
)
(EventData);


// WEBPACK FOOTER //
// ./src/app/components/EventById/Event/EventData.js